//import moment from "moment";

import moment from "moment-timezone";
import Swal from "sweetalert2/dist/sweetalert2.js";
import * as OFMSUI from "react-bootstrap";
import jsPDF from "jspdf";
import {
  IoIosAddCircle,
  IoIosRemoveCircle,
  IoIosCalculator,
} from "react-icons/io"; import ReactHTMLTableToExcel from "react-html-table-to-excel";
import {
  BiRupee,
  BiDownArrowAlt,
  BiLocationPlus,
  BiFlag,
  BiPaperclip,
  BiRightArrowAlt,
  BiCommentDetail,
} from "react-icons/bi";
import { MdLibraryAdd } from "react-icons/md";
import { TiThList } from "react-icons/ti";
import { HiViewGridAdd } from "react-icons/hi";
import { SiAddthis } from "react-icons/si";
import { IoMdDoneAll } from "react-icons/io";
import { CgAttachment } from "react-icons/cg";
import {
  RiShareForwardFill,
  RiArrowGoBackFill,
  RiUserShared2Line,
  RiUserReceivedLine,
  RiUser3Line,
} from "react-icons/ri";
import {
  FaFilePdf,
  FaRegCopy,
  FaEdit,
  FaCalendarAlt,
  FaTrashAlt,
  FaSignOutAlt,
  FaBars,
  FaBookReader,
  FaFileExcel,
} from "react-icons/fa";
import {
  ImFirst,
  ImLast,
  ImHome3,
  ImArrowLeft,
  ImBoxAdd,
} from "react-icons/im";
import {
  RiEditBoxFill,
  RiPrinterFill,
  RiFileExcel2Fill,
  RiSendPlaneFill,
  RiCheckboxMultipleBlankFill,
  RiUpload2Fill,
  RiCloseFill,
} from "react-icons/ri";
import {
  BsEyeFill
} from "react-icons/bs";
import { FiPercent, FiAlignJustify } from "react-icons/fi";
import { GiReturnArrow } from "react-icons/gi";
import { GrNotes, GrFormView } from "react-icons/gr";
import {
  FcProcess,
  FcApproval,
  FcFlowChart,
} from "react-icons/fc";
import { Button } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { AiOutlineExpandAlt } from "react-icons/ai";

import {
  FaUserEdit,
  FaUserCheck,
} from "react-icons/fa";
import { MdVerifiedUser } from "react-icons/md";

import { Popconfirm } from "antd";
import { cloud_url_download } from "../../Services/Configuration";
import axios from "axios";
import ShowAlert from "../alert";
import axiosTokenServiceKeyCloak from "../../Services/axiosTokenServiceKeyCloak";

var createGuest = require("cross-domain-storage/guest");

export const PRINT_ICON = (props) => <RiPrinterFill {...props} />;
export const BACK_ICON = (props) => <ImArrowLeft {...props} />;
export const FW_ICON = (props) => <RiShareForwardFill {...props} />;
export const RETURN_ICON = (props) => <RiArrowGoBackFill {...props} />;
export const APR_ICON = (props) => <IoMdDoneAll {...props} />;
export const COPY_ICON = (props) => <FaRegCopy {...props} />;
export const RUPEE_ICON = (props) => <BiRupee {...props} />;
export const VIEW_ICON = (props) => <BsEyeFill {...props} />;
export const ADDL_ICON = (props) => <MdLibraryAdd {...props} />;
export const BARS_ICON = (props) => <FaBars {...props} />;
export const HOME_ICON = (props) => <ImHome3 {...props} />;
export const CREATE_ICON = (props) => <HiViewGridAdd {...props} />;
export const DRAFT_ICON = (props) => <FaEdit {...props} />;
export const INBOX_ICON = (props) => <ImBoxAdd {...props} />;
export const OUTBOX_ICON = (props) => <FaSignOutAlt {...props} />;
export const LIST_ICON = (props) => <TiThList {...props} />;
export const SEND_ICON = (props) => <RiSendPlaneFill {...props} />;
export const EXECEL_ICON = (props) => <RiFileExcel2Fill {...props} />;
export const PDF_ICON = (props) => <FaFilePdf {...props} />;
export const FIRST_ICON = (props) => <ImFirst {...props} />;
export const LAST_ICON = (props) => <ImLast {...props} />;
export const EDIT_ICON = (props) => <RiEditBoxFill {...props} />;
export const ADD_ICON = (props) => <IoIosAddCircle {...props} />;
export const REMOVE_ICON = (props) => <IoIosRemoveCircle {...props} />;
export const ADDTHIS_ICON = (props) => <SiAddthis {...props} />;
export const ATTACH_ICON = (props) => <CgAttachment {...props} />;
export const LOCATION_ICON = (props) => <BiLocationPlus {...props} />;
export const FLAG_ICON = (props) => <BiFlag {...props} />;
export const PAPERCLIP_ICON = (props) => <BiPaperclip {...props} />;
export const CAL_ICON = (props) => <IoIosCalculator {...props} />;
export const COMMENT_ICON = (props) => <BiCommentDetail {...props} />;
export const MODAL_ICON = (props) => <RiCheckboxMultipleBlankFill {...props} />;
export const UPLOAD_ICON = (props) => <RiUpload2Fill {...props} />;
export const CALENDAR_ICON = (props) => <FaCalendarAlt {...props} />;
export const PERCENTAGE_ICON = (props) => <FiPercent {...props} />;
export const NOTES_ICON = (props) => <GrNotes {...props} />;
export const COLLAPSE_ICON = (props) => <BiRightArrowAlt {...props} />;
export const EXPAND_ICON = (props) => <BiDownArrowAlt {...props} />;

export const PROCESS_ICON = (props) => <FcProcess {...props} />;
export const APPROVED_ICON = (props) => <FcApproval {...props} />;
export const RETURNED_ICON = (props) => <GiReturnArrow {...props} />;

export const CLOSE_ICON = (props) => <RiCloseFill {...props} />;
export const MENU_ICON = (props) => <FiAlignJustify {...props} />;
export const MBOOK_ICON = (props) => <FaBookReader {...props} />;
export const SHOW_ICON = (props) => <GrFormView {...props} />;

export const DOC_FLOW_ICON = (props) => <FcFlowChart {...props} />;

export const S_MAKER_ICON = (props) => <FaUserEdit {...props} />;
export const S_FWD_ICON = (props) => (
  <RiUserShared2Line color="#0fa549" {...props} />
);
export const S_CHECKER_ICON = (props) => <FaUserCheck {...props} />;
export const S_RETURN_ICON = (props) => (
  <>
    <RiUserReceivedLine color="red" {...props} />
  </>
);
export const S_FINISH_ICON = (props) => (
  <MdVerifiedUser color="#0fa549" {...props} />
);
export const S_PENDING_ICON = (props) => (
  <RiUser3Line color="#bfbdbd" {...props} />
);
export const EXPANDTABLE_ICON = (props) => <AiOutlineExpandAlt {...props} />;
export const STEP_ICON = (props) => <GiReturnArrow {...props} />;

export const DELETE_ICON = (props) => <FaTrashAlt {...props} />;

export const DOC_FLOW_LINK = (props) => (
  <Link
    className="btn btn-sm btn-primary"
    role="button"
    to={{
      pathname: "/newDocFlow",
      state: {
        workType: props?.workType,
        subWorkType: props?.subWorkType,
        workId: props?.workId,
      },
    }}
    data-tip="Document Flow"
  >
    <DOC_FLOW_ICON /> Doc Flow{" "}
  </Link>
);
export const BACK_LINK = (props) => {
  const {
    history,
    location,
    match,
    staticContext,
    to,
    onClick,
    // ⬆ filtering out props that `button` doesn’t know what to do with.
    ...rest
  } = props;
  return (
    history?.length > 0 && (
      <Button
        size="sm"
        data-tip="Go Back"
        variant="primary"
        onClick={(event) => {
          onClick && onClick(event);
          if (history.length > 1) {
            history.goBack();
          } else {
            history.push("/home");
          }
        }}
      >
        <BACK_ICON /> BACK
      </Button>
    )
  );
};

// const onClickDocFlow = (workType, subWorkType, workId) =>{
//     const history = useHistory();
//     history.push({pathname:"/newDocFlow", state: {
//         workType: workType,
//         subWorkType: subWorkType,
//         workId: workId
//     }})
// }

//export const AMOUNINPUT = (props) =>

export const showNotification = (type, message) => {
  if (type === "success") {
    Swal.fire("Success", message, "success");
    // NotificationManager.success(message);
  } else if (type === "error") {
    Swal.fire("Error", message, "error");
    // NotificationManager.error(message);
  } else if (type === "warning") {
    Swal.fire("Warning", message, "warning");
    // NotificationManager.warning(message);
  } else if (type === "info") {
    Swal.fire("info", message, "info");
    // NotificationManager.warning(message);
  }
};

export function roundAmount(value) {
  let amount = (parseFloat(value) || 0).toFixed(2);
  return parseFloat(amount);
}

export function roundOfZeroAmount(value) {
  let amount = (parseFloat(value) || 0).toFixed(0);
  return parseFloat(amount);
}

export function amountFormat(value) {
  let amount = (parseFloat(value) || 0).toFixed(2);
  return parseFloat(amount).toLocaleString("en-IN");
}

export function amountQuantity(value) {
  let amount = (parseFloat(value) || 0).toFixed(4);
  return parseFloat(amount).toLocaleString("en-IN");
}

export function dateFormat(date) {
  return date ? moment(date).format("DD-MMM-YYYY  hh:mm A") : "-";
  //moment(time, "HH:mm:ss").format("hh:mm A")
}

export function dateFormatWithoutTime(date) {
  return date ? moment(date).format("DD-MM-YYYY") : "-";
  //return moment(date).format("DD-MM-yyyy");
}

export function roundQuantity(value) {
  let qty = (parseFloat(value) || 0).toFixed(5);
  return parseFloat(qty);
}

export function roundEpcQuantity(value) {
  let qty = (parseFloat(value) || 0).toFixed(10);
  return parseFloat(qty);
}
export const today = new Date();
export const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
// export function isValidNumber(value) {
//   if (value != "") {
//     //var pattern = /^[1-9]\d*(\.\d+)?$/;
//     var pattern = /^[1-9]+(?:)?(\d+)?$/;
//     return pattern.test(value);
//   } else {
//     return true;
//   }
// }

export function isValidNumber(value) {
  if (value !== "") {
    const pattern = /^[1-9]\d*$/;
    return pattern.test(value);
  } else {
    return true;
  }
}


export const NAME_OF_WORK_LENGTH = 50;

export const remaininCharacters = (count, value) => {
  return <>(Remaining Characters : {count - (value?.length || 0)})</>;
};

export const DETAILS_OF_WORK_LENGTH = 500;
export const DETAILS_OF_WORK_LENGTH2 = 100;

export function OnlyNumbers(e) {
  const char = e.key;

  if (!/^[0-9]$/.test(char)) {
    e.preventDefault();
  }
}

// export function isValidFloat(value) {
//     if(value != ""){

//     }
// }

export function isValidFloat(value) {
  if (value != "") {
    // var input = parseFloat(value);
    // var valid = isNaN(input) ? false : true;
    // if (input <= 0) {
    //     valid = false;
    // }
    // return valid
    var pattern = /^[0-9]+(?:\.)?(\d{1,7})?$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

//not allowed stating zero , no chars , length , decimals
export function isValidRate(value) {
  if (value !== "") {
    var pattern = /^[0-9]+(?:\.)?(\d{1,2})?$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

export function isValidQuant(value) {
  if (value !== "") {
    var pattern = /^[0-9]+(?:\.)?(\d{1,3})?$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

export function isValidEpcQuant(value) {
  if (value !== "") {
    var pattern = /^[0-9]+(?:\.)?(\d{1,10})?$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

//Allowing upto 5 decimals
export function isValid(value) {
  if (value !== "") {
    var pattern = /^[0-9]+(?:\.)?(\d{1,5})?$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

//numbers validation
// function isValidNumber(number) {
//   return 0 <= number && number <= 10;
// }

export const NumberValidation = (e) => {
  const key = e.key;

  // Allow control keys
  const allowedKeys = [
    "Backspace",
    "Delete",
    "Tab",
    "ArrowLeft",
    "ArrowRight",
    "Home",
    "End",
  ];

  if (allowedKeys.includes(key)) {
    return;
  }

  // Allow digits
  if (/^[0-9]$/.test(key)) {
    return;
  }

  // Allow only one decimal point
  if (key === ".") {
    if (e.target.value.includes(".")) {
      e.preventDefault();
    }
    return;
  }

  // Block everything else (% included)
  e.preventDefault();
};


// Alphabets + Numbers (with spaces allowed, no special chars)
export const AlphaNumericValidation = (e) => {
  const key = e.key;

  // Allow control keys like Backspace, Tab, Arrow keys, Delete
  if (["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"].includes(key)) {
    return;
  }

  // Allow alphabets and numbers
  if (/^[a-zA-Z0-9]$/.test(key)) {
    return;
  }

  // Allow space
  if (key === " ") {
    return;
  }

  // Block everything else (like %,$,#,@,&, etc.)
  e.preventDefault();
};

//alphabets only
export const allowAlphabetAndSpacesOnly = (e) => {
  var keyCode = e.charCode;

  var value = Number(e.target.value + e.key) || 0;

  if (
    !(keyCode >= 65 && keyCode <= 123) &&
    keyCode !== 32 &&
    keyCode !== 0 &&
    keyCode !== 40 &&
    keyCode !== 41
  ) {
    e.preventDefault();
  } else {
    return value;
  }
  return false;
};

export function isValidPaidQty(value) {
  if (value !== "") {
    var pattern = /^[0-9]+(?:\.)?(\d{1,3})?$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

export function PickerFormat(date) {
  return date ? moment(date).format("DD-MM-yyyy") : "";
}
export const AMOUNT_LENGTH = 12;

export const VALID_TO = moment("31-12-9999", "DD-MM-YYYY").toDate();
//export const VALID_TO = moment('31-12-9999', "yyyy-MM-DD").tz("Asia/Kolkata").format("yyyy-MM-DD");

export const ADD_YEARS_VALID_TO = (date) => {
  return moment(date).add(5, "years").toDate();
};

// export function validTo() {
//     return moment("31-12-9999 ").toDate();
// }

export function groupArrayOfObjects(list, key) {
  return list.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}

export const AGREEMENTAMOUNT = 18;

export function FireConfirmationSwal(msg) {
  Swal.fire({
    icon: "question",
    title: "",
    text: msg,
    confirmButtonText: "OK",
    showCancelButton: true,
  }).then((result) => {
    if (result.isConfirmed) {
      return true;
    } else {
      return false;
    }
  });
  return false;
}

export const SumAmount = (array, keyName) => {
  return array.reduce((sum, row) => parseFloat(row[keyName]) + sum, 0);
};

export const NotesRemaininCharacters = (value) => {
  return <>({500 - (value || 0)})</>;
};

export function convertStringToDate(date) {
  return moment(date, "DD-MM-YYYY");
}

export const COLOUR_STATUS = (props) => {
  let obj = { S01: "#ffbf00", S02: "#4fa0b9", S03: "#6fa000", S04: "#ff4c00" };
  return (
    <>
      <p style={{ color: obj[props?.statusCode], fontSize: "20px" }}>
        <b>{props?.statusDesc}</b>
      </p>
    </>
  );
};

export function DeleteConfirmationPopup(props) {
  return (
    <>
      <Popconfirm
        //placement="rightTop"
        title={"Are you sure want to delete?"}
        onConfirm={() => props.confirm()}
        okText="Yes"
        cancelText="No"
      >
        <Button size="sm" variant="outline-primary">
          Delete
        </Button>{" "}
      </Popconfirm>
    </>
  );
}

export function DeleteConfirmationPopupWithIcon(props) {
  return (
    <>
      <Popconfirm
        //placement="rightTop"
        title={"Are you sure want to delete?"}
        onConfirm={() => props.confirm()}
        okText="Yes"
        cancelText="No"
      >
        {props?.component}{" "}
      </Popconfirm>
    </>
  );
}

export default function allowNumbersOnly(e) {
  var keyCode = e.keyCode === 0 ? e.charCode : e.keyCode;
  var value = Number(e.target.value + e.key) || 0;
  if (keyCode >= 48 && keyCode <= 57) {
    return isValidNumbers(value);
  } else {
    e.preventDefault();
  }
  return false;
}

export function allowOnlyAlphabetsOnlyy(e) {
  const char = e.key;

  if (!/^[A-Za-z ]$/.test(char)) {
    e.preventDefault();
  }
}



const isValidNumbers = (number) => {
  return 1 <= number && number <= 10;
};

export function ClearLocalStorage() {
  localStorage.removeItem("token");
  localStorage.removeItem("serviceList");
  localStorage.clear();
}
export const ModuleHeader = (props) => {
  const history = useHistory();
  return (
    <OFMSUI.Container fluid style={{ width: "90%" }}>
      <OFMSUI.Row>
        <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing">
          <div className="inner-herbpage-service-title1">
            <h1> {props.title} </h1>
          </div>
        </OFMSUI.Col>

        <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" >
          <button className="btn" style={{ textAlign: "right", float: "right", marginTop: "30px", backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }} type="button" onClick={() => history.goBack()}> Back </button>
        </OFMSUI.Col>
      </OFMSUI.Row>
    </OFMSUI.Container>
  )
}
export const GetDetails = () => {
  return (
    <OFMSUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className="mb-3">
      <div className="d-grid mt-2">
        <button type="submit" className="btn btn-sm mt-3" style={{ backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }}>
          Get Details
        </button>
      </div>
    </OFMSUI.Col>
  );
};
export const SubmitButton = (props) => {
  return (
    <>
      <OFMSUI.Row>
        <center>
          <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
            {" "}
            <button className="btn btn-success btn" type="submit">
              {props.title}
            </button>
          </OFMSUI.Col>
        </center>

      </OFMSUI.Row>
    </>
  )

}
export const GetDetailsButton = (props) => {
  return (
    <OFMSUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className="mb-3">
      <div className="d-grid mt-2">
        <button type="button" className="btn btn-success btn-sm mt-3">
          {props.title}
        </button>
      </div>
    </OFMSUI.Col>
  );
};


export const generatePDF = (tableId, title = "Report", fileName = "report.pdf", columnsCount) => {
  const pageWidth = 250;
  const pageHeight = 297;
  const doc = new jsPDF({
    orientation: "potrait",
    unit: "mm",
    format: [pageWidth, pageHeight],
  });
  const rightOffset = 8;

  const centerText = (text, fontSize) => {
    const textWidth = (doc.getStringUnitWidth(text) * fontSize) / doc.internal.scaleFactor;
    return (pageWidth - textWidth) / 2 + rightOffset;
  };

  const logoUrl = '/img/APSHCL_logo.png';
  const imgWidth = 16;
  const imgHeight = 16;

  doc.addImage(logoUrl, 'PNG', 10, 12, imgWidth, imgHeight);
  doc.setFont("serif", "normal");

  doc.setFontSize(12);
  doc.text("GOVERNMENT OF ANDHRA PRADESH", centerText("GOVERNMENT OF ANDHRA PRADESH", 12), 10);

  const apshclText = "Andhra Pradesh State Housing Corporation Limited (APSHCL)";
  doc.setFontSize(12);
  doc.text(apshclText, centerText(apshclText, 12), 18);

  const formattedDate = new Date().toLocaleDateString("en-GB");
  const titleText = `${title}`;
  doc.setFontSize(12);
  doc.text(titleText, centerText(titleText, 12), 26);

  const table = document.getElementById(tableId);
  const rows = [];

  const headers = Array.from(table.querySelectorAll("thead tr th"))
    .slice(0, columnsCount)
    .map(th => th.innerText);

  rows.push(headers);

  const bodyRows = table.querySelectorAll("tbody tr");
  bodyRows.forEach(row => {
    const cols = Array.from(row.querySelectorAll("td"))
      .slice(0, columnsCount)
      .map(td => td.innerText);
    rows.push(cols);
  });

  doc.autoTable({
    head: [headers],
    body: rows.slice(1),
    theme: "striped",
    startY: 30,
    styles: { fontSize: 8 },
    columnStyles: { 12: { cellWidth: "wrap" } },
  });

  doc.save(fileName);
};
// export const generatePDF = (tableId, title = "Report", fileName = "report.pdf", columnsCount) => {
//   const pageWidth = 250;
//   const pageHeight = 297;
//   const doc = new jsPDF({
//     orientation: "portrait",
//     unit: "mm",
//     format: [pageWidth, pageHeight],
//   });
//   const rightOffset = 8;

//   const centerText = (text, fontSize) => {
//     const textWidth = (doc.getStringUnitWidth(text) * fontSize) / doc.internal.scaleFactor;
//     return (pageWidth - textWidth) / 2 + rightOffset;
//   };

//   const logoUrl = '/img/APSHCL_logo.png';
//   const imgWidth = 16;
//   const imgHeight = 16;

//   doc.addImage(logoUrl, 'PNG', 10, 12, imgWidth, imgHeight);
//   doc.setFont("serif", "normal");

//   doc.setFontSize(12);
//   doc.text("GOVERNMENT OF ANDHRA PRADESH", centerText("GOVERNMENT OF ANDHRA PRADESH", 12), 10);

//   const apshclText = "Andhra Pradesh State Housing Corporation Limited (APSHCL)";
//   doc.setFontSize(12);
//   doc.text(apshclText, centerText(apshclText, 12), 18);

//   const formattedDate = new Date().toLocaleDateString("en-GB");
//   const titleText = `${title} - ${formattedDate}`;
//   doc.setFontSize(12);
//   doc.text(titleText, centerText(titleText, 12), 26);

//   const table = document.getElementById(tableId);
//   const rows = [];

//   // Get headers, adjusting for the columns with checkboxes
//   const headers = Array.from(table.querySelectorAll("thead tr th"))
//     .slice(0, columnsCount) 
//     .map(th => th.innerText);

//   rows.push(headers); // Push the original headers

//   const bodyRows = table.querySelectorAll("tbody tr");
//   bodyRows.forEach(row => {
//     const cols = Array.from(row.querySelectorAll("td"))
//       .slice(0, columnsCount) 
//       .map(td => td.innerText);

//     // Get checkbox statuses for the 4th and 5th columns
//     const checkbox1 = row.querySelector("td:nth-child(4) input[type='checkbox']");
//     const checkbox2 = row.querySelector("td:nth-child(5) input[type='checkbox']");

//     const checkbox1Status = checkbox1 && checkbox1.checked ? "Yes" : "No";
//     const checkbox2Status = checkbox2 && checkbox2.checked ? "Yes" : "No";

//     // Insert the checkbox statuses into the appropriate positions
//     cols[3] = checkbox1Status; // Replace the 4th column's value with checkbox status
//     cols[4] = checkbox2Status; // Replace the 5th column's value with checkbox status

//     rows.push(cols); // Push the updated row
//   });

//   doc.autoTable({
//     head: [headers], 
//     body: rows.slice(1), 
//     theme: "striped",
//     startY: 30,
//     styles: { fontSize: 8 },
//     columnStyles: { 12: { cellWidth: "wrap" } },
//   });

//   doc.save(fileName);
// };

export const LabelHeader = (props) => {
  return (
    <label>{props.title} <span className="mandatory" style={{ color: "red" }}> * </span> </label>
  )
}

export const FormHeader = (props) => {
  return (
    <OFMSUI.Row style={{ marginTop: "1rem" }}>
      <div className="inner-herbpage-service-title-sub">
        <h1> {props.title}</h1>
      </div>
    </OFMSUI.Row>
  )
}
export const todayDate = new Date().toISOString().split('T')[0];



export const DashboardServiceReport = (props) => {
  return (
    <OFMSUI.Row>
      <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
        <ol className="breadcrumb">
          <li className="breadcrumb-item"> <a href="Dashboardheader">Dashboard</a> </li>
          <li className="breadcrumb-item active" aria-current="page"> {props.title} </li>
        </ol>
      </OFMSUI.Col>
    </OFMSUI.Row>
  )
}

export const generateNMRPayslip = (item = {}, emp_id = "", displayempname = "", displayEmpType = "", designation = "") => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const safeText = (value) => String(value || "");

  doc.setFontSize(10);
  doc.setTextColor(0, 0, 255);
  doc.text("apshclfms.apcfss.in/Emp_Pay_Particulars", 105, 7, { align: "center" });

  const logoUrl = "/img/APSHCL_logo.png";
  doc.addImage(logoUrl, "PNG", 15, 15, 24, 24);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.setTextColor(0, 51, 102);
  doc.text("GOVERNMENT OF ANDHRA PRADESH", 105, 22, { align: "center" });
  doc.setFontSize(10);
  doc.text("ANDHRA PRADESH STATE HOUSING CORPORATION LIMITED (APSHCL)", 105, 30, { align: "center" });
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.setTextColor(0, 51, 102);
  doc.text(`Payslip for the month of ${safeText(item.month_name)}, ${safeText(item.year)}`, 105, 38, { align: "center" });

  doc.setFontSize(10);
  doc.setTextColor(0);
  doc.setFont("helvetica", "bold");
  doc.text("Employee Details:", 15, 50);

  let startY = 58;
  const lineGap = 6;
  const labelX = 15;
  const colonX = 60;
  const valueX = 65; // Adjusted to maintain proper alignment

  const employeeDetails = [
    ["Employee Name", displayempname],
    ["Employee ID", emp_id],
    ["Designation", designation],
    ["Employee Type", displayEmpType],
    ["Payment Type", item.payment_type],
  ];

  employeeDetails.forEach(([label, value]) => {
    doc.text(label, labelX, startY);
    doc.text(":", colonX, startY);
    doc.text(safeText(value), valueX, startY);
    startY += lineGap;
  });

  let earningsAndDeductions = [
    ["Earnings", safeText(item.nmr_gross_earnings), "FA Deductions", safeText(item.nmr_fa_deductions)],
    ["", "", "Postal RD Deductions", safeText(item.nmr_postalrd_deductions)],
    ["", "", "Professional Tax", safeText(item.os_prof_tax_deductions)],
    ["", "", "EES EPF Deductions", safeText(item.os_ees_epf_deductions)],
    ["", "", "EA Deductions", safeText(item.nmr_ea_deductions)],
    ["", "", "MA Deductions", safeText(item.nmr_ma_deductions)],
    ["", "", "LIC Deductions", safeText(item.nmr_lic_deductions)],
    ["", "", "TDS Deductions", safeText(item.nmr_tds_deductions)],
    ["", "", "Other Liabilities", safeText(item.nmr_otherliab_deductions)],
    ["Total Earnings", safeText(item.total_earnings), "Total Deductions", safeText(item.total_deductions)],
  ];

  let netPay = (item.total_earnings || 0) - (item.total_deductions || 0);

  doc.text("Earnings & Deductions", 15, startY + 10);
  doc.autoTable({
    startY: startY + 15,
    head: [["Earnings", "Amount", "Deductions", "Amount"]],
    body: earningsAndDeductions,
    theme: "grid",
    styles: { fontSize: 9, lineWidth: 0.5, fontStyle: "normal", textColor: [0, 0, 0], lineColor: [0, 0, 0] },
    headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], fontStyle: "normal" }, // No color
    columnStyles: {
      0: { cellWidth: 50 },
      1: { cellWidth: 40 },
      2: { cellWidth: 50 },
      3: { cellWidth: 40 },
    },
  });


  doc.setFontSize(12);
  doc.text("Net Pay for the month: Rs " + netPay, 75, doc.autoTable.previous.finalY + 10);
  doc.setFontSize(10);
  doc.text("This is a system-generated payslip and does not required signature.", 15, doc.autoTable.previous.finalY + 20);

  doc.save(`Payslip_${safeText(item.month_name)}_${safeText(item.year)}.pdf`);
};









export const generateConsultantPayslip = (item = {}, emp_id = "", displayempname = "", displayEmpType = "", designation = "") => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const safeText = (value) => String(value || "");

  doc.setFontSize(10);
  doc.setTextColor(0, 0, 255);
  doc.text("apshclfms.apcfss.in/Emp_Pay_Particulars", 105, 7, { align: "center" });

  const logoUrl = "/img/APSHCL_logo.png";
  doc.addImage(logoUrl, "PNG", 15, 15, 24, 24);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.setTextColor(0, 51, 102);
  doc.text("GOVERNMENT OF ANDHRA PRADESH", 105, 22, { align: "center" });
  doc.setFontSize(10);
  doc.text("ANDHRA PRADESH STATE HOUSING CORPORATION LIMITED (APSHCL)", 105, 30, { align: "center" });
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.setTextColor(0, 51, 102);
  doc.text(`Payslip for the month of ${safeText(item.month_name)}, ${safeText(item.year)}`, 105, 38, { align: "center" });

  doc.setFontSize(10);
  doc.setTextColor(0);
  doc.setFont("helvetica", "bold");
  doc.text("Employee Details:", 15, 50);

  let startY = 58;
  const lineGap = 6;
  const labelX = 15;
  const colonX = 60;
  const valueX = 65;

  const employeeDetails = [
    ["Employee Name", displayempname],
    ["Employee ID", emp_id],
    ["Designation", designation],
    ["Employee Type", displayEmpType],
    ["Payment Type", item.payment_type],
  ];

  employeeDetails.forEach(([label, value]) => {
    doc.text(label, labelX, startY);
    doc.text(":", colonX, startY);
    doc.text(safeText(value), valueX, startY);
    startY += lineGap;
  });

  let earningsAndDeductions = [
    ["Basic Pay Earnings", safeText(item.os_basic_pay_earnings), "EES EPF Deductions", safeText(item.os_ees_epf_deductions)],
    ["CA Earnings", safeText(item.os_ca_earnings), "ERS EPF Deductions", safeText(item.os_ers_epf_deductions)],
    ["EC EPF Earnings", safeText(item.os_ec_epf), "Professional Tax", safeText(item.os_prof_tax_deductions)],
    ["Performance Earnings", safeText(item.os_performance_earnings), "Other Deductions", safeText(item.os_other_deductions)],
    ["HRA Earnings", safeText(item.os_hra_earnings), "", ""],
    ["Medical Earnings", safeText(item.os_medical_earnings), "", ""],
    ["Total Earnings", safeText(item.total_earnings), "Total Deductions", safeText(item.total_deductions)],
  ];

  let netPay = (item.total_earnings || 0) - (item.total_deductions || 0);

  doc.text("Earnings & Deductions", 15, startY + 10);
  doc.autoTable({
    startY: startY + 15,
    head: [["Earnings", "Amount", "Deductions", "Amount"]],
    body: earningsAndDeductions,
    theme: "grid",
    styles: {
      fontSize: 9,
      lineWidth: 0.5,
      fontStyle: "normal",
      textColor: [0, 0, 0],
      lineColor: [0, 0, 0]  // Set table border lines to black
    },
    headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], fontStyle: "normal" },
    columnStyles: {
      0: { cellWidth: 50 },
      1: { cellWidth: 40 },
      2: { cellWidth: 50 },
      3: { cellWidth: 40 },
    },
  });

  doc.setFontSize(12);
  doc.text("Net Pay for the month: Rs " + netPay, 75, doc.autoTable.previous.finalY + 10);
  doc.setFontSize(10);
  doc.text("This is a system-generated payslip and does not required signature.", 15, doc.autoTable.previous.finalY + 20);

  doc.save(`Payslip_${safeText(item.month_name)}_${safeText(item.year)}.pdf`);
};




export const generateRegularPayslip = (item, displayempname, displayEmpType, designation) => {

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 255); // Blue color for URL
  doc.text("apshclfms.apcfss.in/Emp_Pay_Particulars.do", 105, 7, null, null, "center");
  // Add Background Border
  // doc.setDrawColor(0);
  // doc.setLineWidth(1);
  // doc.rect(10, 10, 190, 277); // Outer border

  // Load Logo
  const logoUrl = "/img/APSHCL_logo.png";
  doc.addImage(logoUrl, "PNG", 15, 15, 24, 24);


  // Header
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.setTextColor(0, 51, 102);

  doc.text("GOVERNMENT OF ANDHRA PRADESH", 105, 20, null, null, "center");
  doc.text("ANDHRA PRADESH STATE HOUSING CORPORATION LIMITED (APSHCL)", 105, 30, null, null, "center");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.setTextColor(0, 51, 102);
  doc.text(`Payslip for the month of ${item.month_name}, ${item.year}`, 105, 38, null, null, "center");

  // Employee Details
  doc.setFontSize(10);
  doc.setTextColor(0);
  doc.setFont("helvetica", "bold");
  doc.text("Employee Details:", 15, 50);
  doc.autoTable({
    startY: 55,
    // head: [["Employee", "Details", "", ""]],
    body: [
      ["Employee Name", displayempname, "Employee ID", item.emp_id],
      ["Designation", designation, "Employee Type", displayEmpType],
      ["Payment Type", item.payment_type, "", ""],
      // ["Designation", item.designation, "Payment Type", item.payment_type],
    ],
    theme: "grid",
    styles: { fontSize: 9, lineWidth: 0.5, fontStyle: "normal", textColor: [0, 0, 0], lineColor: [0, 0, 0] },
    headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
    columnStyles: {
      0: { cellWidth: 30 },
      1: { cellWidth: 80 },
      2: { cellWidth: 30 },
      3: { cellWidth: 32 },
    },
  });


  let totalHBA = [
    item.hba1_loan, item.hba_loan, item.hbao_loan,
  ].reduce((sum, value) => sum + (value ?? 0), 0);

  let totalADDHBA = [
    item.add_hba_loan, item.add_hba1_loan,
  ].reduce((sum, value) => sum + (value ?? 0), 0);

  let totalMCA = [
    item.mca_i_loan, item.mca_a_loan,
  ].reduce((sum, value) => sum + (value ?? 0), 0);


  // Earnings & Deductions & Loan Deductions
  doc.setFontSize(10);
  doc.setTextColor(0);
  doc.setFont("helvetica", "bold");
  doc.text("Earnings, Deductions & Loan Details", 15, doc.autoTable.previous.finalY + 10);
  // Prepare the earnings, deductions, and loan details dynamically
  let tableData = [
    ["Basic", item.basic_pay_earnings, "APGLIL", item.apglil_deductions, "Add HBA Advance", (totalADDHBA)],
    ["CA", item.ca_earnings, "APGLIS", item.apglis_deductions, "Car Advance", (item.car_a_loan ?? 0) + (item.car_i_loan ?? 0)],
    ["CCA", item.cca_earnings, "CCA", item.cca_deductions, "Comp Advance", (item.comp1_loan ?? 0) + (item.comp_loan ?? 0)],
    ["DA", item.da_earnings, "CMRF", item.cmrf_deductions, "Court Recovery", item.court_loan],
    ["GP", item.gp_earnings, "Con", item.con_decd_deductions, "Cycle Advance", (item.cyc_a_loan ?? 0) + (item.cyc_i_loan ?? 0)],
    ["HRA", item.hra_earnings, "EPF", item.epf_deductions, "HBA Advance", totalHBA],
    ["IR", item.ir_earnings, "EPFL", item.epf_l_deductions, "EA Recovery", item.ea_loan],
    ["Medical", item.medical_earnings, "FCF", item.fcf_deductions, "HCESA Advance", (item.hcesa_i_loan ?? 0) + (item.hcesa_loan ?? 0)],
    ["Per Pay", item.per_pay_earnings, "GIS", item.gis_deductions, "HR arrear Advance", item.hr_arrear_loan],
    ["Spl Pay", item.spl_pay_earnings, "GPFL", item.gpfl_deductions, "Festival Advance", item.fa_loan],
    ["Sc", item.sca, "GPFS", item.gpfs_deductions, "MAR Advance", (item.mar_a_loan ?? 0) + (item.mar_i_loan ?? 0)],
    ["Spl All", item.spl_all, "GPFSA", item.gpfsa_deductions, "MCA Advance", (totalMCA)],
    ["", "", "PPF", item.ppf_deductions, "Med Advance", (item.med_a_i_loan ?? 0) + (item.med_a_loan ?? 0)],
    ["", "", "VPF", item.vpf_deductions, "Sal Advance", item.sal_adv_loan],
    ["", "", "PT", item.pt_deductions, "SFA Advance", item.sfa_loan],
    ["", "", "IT", item.it_deductions, "Staff I Advance", item.staff_pl_loan],
    ["", "", "LIC", item.lic_deductions, "Bank Recovery", item.vij_bank_loan],
    ["", "", "RCS Cont", item.rcs_cont_deductions, "Cell Phone Recovery", (item.cell_loan ?? 0)],
    ["", "", "Other Deductions", item.other_deductions, "", ""],
    ["Total Earnings", item.total_earnings, "Total Deductions", item.total_deductions, "Total Loan", item.total_loan]
  ];

  // **Filter out rows where ALL columns (earnings, deductions, loans) are null, undefined, or 0**
  let filteredTableData = tableData.filter(row =>
    [row[1], row[3], row[5]].some(value => value !== null && value !== undefined && parseFloat(value) !== 0)
  );

  // **Generate table only with non-zero rows**
  doc.text("Earnings, Deductions & Loan Details", 15, doc.autoTable.previous.finalY + 10);
  doc.autoTable({
    startY: doc.autoTable.previous.finalY + 15,
    head: [["Earnings", "Amount", "Deductions", "Amount", "Loan / Advances Recovery", "Amount"]],
    body: filteredTableData,
    theme: "grid",
    styles: { fontSize: 9, lineWidth: 0.5, fontStyle: "normal", textColor: [0, 0, 0], lineColor: [50, 50, 50] },
    headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], fontStyle: "bold" },
    columnStyles: {
      0: { cellWidth: 30 },
      1: { cellWidth: 25 },
      2: { cellWidth: 30 },
      3: { cellWidth: 25 },
      4: { cellWidth: 40 },
      5: { cellWidth: 25 },
    },
  });

  // Net Pay Calculation
  const totalEarnings = item.total_earnings ?? 0;
  const totalDeductions = item.total_deductions ?? 0;
  const totalLoan = item.total_loan ?? 0;
  const netPay = totalEarnings - totalDeductions - totalLoan;

  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text(`Net Pay for the month: Rs ${netPay}`, 75, doc.autoTable.previous.finalY + 10);

  // Disclaimer
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("This is a system-generated payslip and does not required signature.", 15, doc.autoTable.previous.finalY + 20);

  // Save PDF
  doc.save(`Payslip_${item.month_name}_${item.year}.pdf`);
};
export const ModuleHeaderTitle = (props) => {
  return (
    <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing">
      <div className="inner-herbpage-service-title1">
        <h1> {props.title} </h1>
      </div>
    </OFMSUI.Col>
  )
}
export const ModuleHeaderBack = () => {
  return (
    <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" >
      <button className="btn btn-primary" style={{ textAlign: "right", float: "right", marginTop: "30px" }} type="reset" > Back </button>
    </OFMSUI.Col>
  )
}


export const formatINR = (value) => {
  if (value === null || value === undefined || isNaN(value)) return "-";
  return Number(value).toLocaleString("en-IN");
};

export const formatIndianNumber = (num) => {
  if (num == null) return "0"; // handle null/undefined
  return num < 0
    ? `(${Math.abs(num).toLocaleString("en-IN")})`
    : num.toLocaleString("en-IN");
};


export const formatDateForInput = (dateStr) => {
  if (!dateStr) return "";
  const [day, month, year] = dateStr.split("-");
  return `${year}-${month}-${day}`;
};


export const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    const validType = ["application/pdf", "image/jpeg", "image/jpg", "image/png"]; const maxSize = 2 * 1024 * 1024;
    if (validType.includes(file.type)) {
      if (file.size > maxSize) {
        ShowAlert("File Size Exceeds The Limit Of 2 MB Only", "error"); e.target.value = ""; return false;
      }
    } else {
      ShowAlert("Only PDF and Image Files Are Allowed", "error"); e.target.value = "";
    }
  }
};


export const handleDownload = async (upload_copy) => {
  try {
    const response = await axiosTokenServiceKeyCloak({
      url: `${cloud_url_download}apofms/BRS&file=${upload_copy}`,
      method: "GET",
      responseType: "blob"
    });

    // create a link element
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;

    // use upload_copy as filename (or fallback)
    const filename = upload_copy || "file.pdf";
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();

    // cleanup
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Download failed", error);
  }
};

export const ExportToExcelButton = ({ tableId, filename, sheet, buttonText }) => {
  return (
    <button
      type="button"
      className="btn btn-success btn-sm"
      style={{ float: "right", color: "#fff", marginLeft: "1px", display: "flex", alignItems: "center", gap: "5px" }}
    >
      {/* Excel Icon */}
      <FaFileExcel size={16} />

      {/* ReactHTMLTableToExcel button (text part) */}
      <ReactHTMLTableToExcel
        id={`${tableId}-xls-button`}
        className="download-table-xls-button"
        table={tableId}
        filename={filename}
        sheet={sheet}
        buttonText={buttonText}
        type="button"
      />
    </button>
  );
};

export const loginuser = localStorage.getItem("username");